<template>
    <section
        class="filters-panel filters-panel--border-bottom row filters-panel__row"
    >
        <div class="col-lg-2 filters-panel__col d-none d-lg-block">
            <div class="loading-state__filter"></div>
        </div>
        <div class="col-lg-2 filters-panel__col d-none d-lg-block">
            <div class="loading-state__filter"></div>
        </div>
        <div class="col-lg-2 filters-panel__col d-none d-lg-block">
            <div class="loading-state__filter"></div>
        </div>
        <div class="col-lg-2 filters-panel__col d-none d-lg-block">
            <div class="loading-state__filter"></div>
        </div>
        <div class="col-lg-2 filters-panel__col d-none d-lg-block">
            <div class="loading-state__filter"></div>
        </div>
        <div class="col-lg-2 filters-panel__col d-none d-lg-block">
            <div class="loading-state__filter"></div>
        </div>
        <div class="col-lg-2 filters-panel__col d-none d-lg-block">
            <div class="loading-state__filter"></div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'FiltersLoadingNoSearch'
}
</script>
